export default "__VITE_ASSET__Dnu8847z__"